import { ResultOf } from 'gql.tada';
import { gql } from '../../gql';

export const GET_WATER_SERVICE_IDS = gql(`
  query GetWaterServiceIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
    $includeAddress: Boolean = false
  ) {
    waterServices(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
      address @include(if: $includeAddress) {
        latitude
        longitude
      }
    }
  }
`);

export const GET_WATER_SERVICES = gql(`
  query GetWaterServices(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterServices(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      siteNumber
      meterNumber
      pin
      tags
      recycledWaterSite {
        id
        name
      }
      hazardSite {
        id
        name
      }
      status
      type
      radioId
      hazardProtectionStatus
      hasBackflowAssemblies
      address(required: true) {
        street1
        street2
        city
        state
        zip
        zipExt
      }
    }
  }
`);

export type WaterServiceItem = ResultOf<
  typeof GET_WATER_SERVICES
>['waterServices'][number];
